<template>
  <div class="ab-ui-select">
    <label v-if="label" class="ab-ui-select__label">
      {{ label }}
    </label>
    <div class="ab-ui-select__control" :class="{ 'ab-ui-select__control--error': error }">
      <select
        class="ab-ui-select__native"
        :value="value"
        @change="$emit('input', $event.target.value)"
      >
        <option v-if="placeholder" disabled value="">{{ placeholder }}</option>
        <option
          v-for="item in items"
          :key="item.value"
          :value="item.value"
        >
          {{ item.text }}
        </option>
      </select>
    </div>
    <p v-if="error" class="ab-ui-select__error">
      {{ error }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'AbUiSelect',
  props: {
    value: [String, Number],
    label: String,
    placeholder: String,
    items: {
      type: Array,
      default: () => [],
    },
    error: String,
  },
}
</script>

<style scoped>
.ab-ui-select {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.ab-ui-select__label {
  font-size: 12px;
  color: #555;
}

.ab-ui-select__control {
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  background-color: #fff;
  padding: 4px 8px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.ab-ui-select__control--error {
  border-color: #f44336;
}

.ab-ui-select__native {
  border: none;
  outline: none;
  width: 100%;
  font-size: 13px;
  background: transparent;
  padding: 4px 0;
}

.ab-ui-select__error {
  font-size: 11px;
  color: #f44336;
  margin: 0;
}
</style>

